import { createStore } from 'vuex'
import state from "./state"
import mutations from './mutations'
import actions from "./actions"

/*let state = {
    config: null,
}*/
export default createStore({
    state,
    mutations,
    actions
})